import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Text, NextImage, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { StBox, StRichText, CriteriaRichText } from './ViewTrials.styles';
import { mergeTag } from '../../../lib/utils/common';
import { StNextImage } from '../../shared/NextImage.styles';
import UiHeading from '../../shared/Heading';

const ViewTrials: React.FC<any> = (props) => {
  const [inclusionExclusionPostTextWithTag, setInclusionExclusionPostTextWithTag] = useState<
    string | ''
  >('');
  const { sitecoreContext } = useSitecoreContext();

  const route: any = sitecoreContext?.route;
  const aboutStudyIcon = props?.fields?.aboutStudyIcon;
  const aboutStudyText = props?.fields?.aboutStudyText;
  const whoCanTakePartIcon = props?.fields?.whoCanTakePartIcon;
  const whoCanTakePartText = props?.fields?.whoCanTakePartText;
  const inclusionExclusionPreText = props?.fields?.inclusionExclusionPreText;
  const inclusionHeadingText = props?.fields?.inclusionHeadingText;
  const exclusionHeadingText = props?.fields?.exclusionHeadingText;
  const inclusionExclusionPostText = props?.fields?.inclusionExclusionPostText;
  const exclusionCriteria = route?.fields?.exclusionCriteria;
  const inclusionCriteria = route?.fields?.inclusionCriteria;
  const iconColor = props?.fields?.iconColor?.value;
  const nctid = route?.name;
  const showWhoCanTakePartSection =
    inclusionCriteria?.value !== '' || exclusionCriteria?.value !== '';
  useEffect(() => {
    if (nctid === undefined) return;
    const textWithTag = mergeTag(inclusionExclusionPostText.value, {
      nctid: nctid,
    });

    setInclusionExclusionPostTextWithTag(textWithTag);
  }, [inclusionExclusionPostText.value, nctid]);

  return (
    <>
      <style jsx global>{`
        /* Hide nctid section on initial load in iframe mode to prevent flicker */
        html.iframe-mode .view-trials-nctid {
          display: none !important;
        }
      `}</style>
      <Grid sx={{ marginBottom: '1rem' }}>
        <Grid>
          <Grid>
            <StBox>
              {aboutStudyIcon?.value?.src &&
                (iconColor ? (
                  <StNextImage field={aboutStudyIcon} overrideIconColor={iconColor} />
                ) : (
                  <NextImage field={aboutStudyIcon} />
                ))}
              <UiHeading size="h3" isChildren color="primary">
                <Text field={aboutStudyText} />
              </UiHeading>
            </StBox>
            <StRichText field={route?.fields?.trialDescription} />
          </Grid>
          {showWhoCanTakePartSection && (
            <Grid id="who-can-take-part">
              <StBox>
                {whoCanTakePartIcon?.value?.src &&
                  (iconColor ? (
                    <StNextImage field={whoCanTakePartIcon} overrideIconColor={iconColor} />
                  ) : (
                    <NextImage field={whoCanTakePartIcon} />
                  ))}
                <UiHeading size="h3" isChildren color="primary">
                  <Text field={whoCanTakePartText} />
                </UiHeading>
              </StBox>
              <Grid sx={{ fontSize: '16px', fontWeight: 600 }}>
                <StRichText field={inclusionExclusionPreText} />
              </Grid>
              {inclusionCriteria?.value !== '' && (
                <Grid id="inclusion-criteria">
                  <StBox>
                    <UiHeading className="--force-h4 _color" size="h4" isChildren color="primary">
                      <Text field={inclusionHeadingText} />
                    </UiHeading>
                  </StBox>
                  <CriteriaRichText field={inclusionCriteria} />
                </Grid>
              )}
              {exclusionCriteria?.value !== '' && (
                <Grid id="exclusion-criteria">
                  <StBox>
                    <UiHeading size="h4" className="--force-h4 _color" isChildren color="primary">
                      <Text field={exclusionHeadingText} />
                    </UiHeading>
                  </StBox>
                  <CriteriaRichText field={exclusionCriteria} />
                </Grid>
              )}
              {nctid && (
                <StRichText
                  className="view-trials-nctid"
                  field={{ value: inclusionExclusionPostTextWithTag }}
                />
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ViewTrials;
